export default "__VITE_ASSET__C4Pi4gZi__"